import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { InspectionModelService, InspectionService } from '../../../shared/services/index';
import { BaseModalPageComponent } from '../../../base-modal.component';

import * as _ from 'lodash';

@Component({
    templateUrl: './model-sections.component.html',
    standalone: false
})
export class ModelSectionsPageComponent extends BaseModalPageComponent implements OnInit {
  model: any;
  inspectionId: string;
  modelId: string;
  selectedSections: any;
  errorMessage: string;
  createProcessing = false;

  public loading: Boolean = true;

  constructor(
    public modelService: InspectionModelService,
    public inspectionService: InspectionService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private cdRef: ChangeDetectorRef
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['targetId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const modelId = params['modelId'];
      if (modelId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.modelId = modelId;
      this.initData();
    });
  }

  selectInspectionSection(inspectionSection: any): void {
    inspectionSection.selected = !inspectionSection.selected;
    this.selectedSections = _.filter(this.model.sections, (s: any) => s.selected).sort((el) => el.order);
    this.cdRef.detectChanges();
  }

  addSection(): void {
    this.createProcessing = true;
    let sectionsIds = _.map(this.selectedSections, (el: any) => el.id);
    this.inspectionService.addSection(this.inspectionId, this.modelId, sectionsIds).subscribe((data) => {
      this.resetSelectedSections();
      window.history.go(-2);
    });
  }

  cancel() {
    this.resetSelectedSections();
    this.goToBack();
  }

  initData(): void {
    this.modelService.getModel(this.modelId).subscribe((model) => {
      this.model = model;
      this.loading = false;
    });
  }

  resetSelectedSections() {
    if (this.selectedSections) {
      this.selectedSections.forEach((s) => (s.selected = false));
    }
  }
}
